module.exports = __webpack_public_path__ + "QB Import Template.xlsx";